import React, { useState, useEffect } from "react";
import "./SkilloreaHomeslider.css"; // Import CSS file for styles

const Slider = () => {
  const data = [
    {
      title: "Learning is Fun and Personalized ",
      description: "A platform for",
      text: " learning adventures ",
      image: "assets/img/skillorea/slide1.png",
      buttons: [
        {
          link: "https://apps.apple.com/us/app/your-app-name/id123456789",
          type: "primary",
          image: "assets/img/skillorea/playstore.png", // Image for Button 1
          text: "Button 1", // Optional, for accessibility purposes
        },
        {
          link: "https://play.google.com/store/apps/details?id=com.yourcompany.yourapp",
          type: "secondary",
          image: "assets/img/skillorea/appstore.png", // Image for Button 2
          text: "Button 2", // Optional, for accessibility purposes
        },
        {
          link: "https://skillorea.com/",
          type: "tertiary",
          image: "assets/img/skillorea/gotolive.png", // Image for Button 3
          text: "Button 3", // Optional, for accessibility purposes
        },
      ],
    },
    {
      title: "Skills, wellness, SkillOrea",
      description: "Engage deeply,",
      text: " learn your way, and love it ",
      image: "assets/img/skillorea/slide1.png",
      buttons: [
        {
          link: "https://apps.apple.com/us/app/your-app-name/id123456789",
          type: "primary",
          image: "assets/img/skillorea/playstore.png", // Image for Button 1
          text: "Button 1", // Optional, for accessibility purposes
        },
        {
          link: "https://play.google.com/store/apps/details?id=com.yourcompany.yourapp",
          type: "secondary",
          image: "assets/img/skillorea/appstore.png", // Image for Button 2
          text: "Button 2", // Optional, for accessibility purposes
        },
        {
          link: "https://skillorea.com/",
          type: "tertiary",
          image: "assets/img/skillorea/gotolive.png", // Image for Button 3
          text: "Button 3", // Optional, for accessibility purposes
        },
      ],
    },
    {
      title: "AI Learning, smarter result",
      description: "Learn intelligently,",
      text: " achieve more ",
      image: "assets/img/skillorea/slide1.png",
      buttons: [
        {
          link: "https://apps.apple.com/us/app/your-app-name/id123456789",
          type: "primary",
          image: "assets/img/skillorea/playstore.png", // Image for Button 1
          text: "Button 1", // Optional, for accessibility purposes
        },
        {
          link: "https://play.google.com/store/apps/details?id=com.yourcompany.yourapp",
          type: "secondary",
          image: "assets/img/skillorea/appstore.png", // Image for Button 2
          text: "Button 2", // Optional, for accessibility purposes
        },
        {
          link: "https://skillorea.com/",
          type: "tertiary",
          image: "assets/img/skillorea/gotolive.png", // Image for Button 3
          text: "Button 3", // Optional, for accessibility purposes
        },
      ],
    },
    // Add more slides as needed
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (!isTransitioning) {
      const interval = setInterval(() => {
        setIsTransitioning(true);
        setCurrentSlide((prev) => (prev + 1) % data.length);
      }, 3000); // Change slide every 3 seconds

      return () => clearInterval(interval); // Clean up interval on component unmount
    }
  }, [isTransitioning, data.length]);

  // Handle the transition end event and reset the transition state
  const handleTransitionEnd = () => {
    setIsTransitioning(false);
  };

  const handleCircleClick = (index) => {
    setCurrentSlide(index);
    setIsTransitioning(true);
  };

  return (
    <div className="slider-container">
      <div
        className="slider"
        style={{
          transform: `translateX(-${currentSlide * 100}%)`,
          transition: isTransitioning ? "transform 1s ease" : "none",
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {data.map((item, index) => (
          <div className="slide" key={index}>
            <div className="content">
              <h2>{item.title}</h2>
              <h6>{item.description}</h6>
              <p>{item.text}</p>
              <div className="buttons">
                {item.buttons.map((button, idx) => (
                  <a
                    key={idx}
                    href={button.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`btn ${
                      button.type === "primary"
                        ? "primary-button"
                        : button.type === "secondary"
                        ? "secondary-button"
                        : "tertiary-button"
                    }`}
                  >
                    <img
                      src={button.image}
                      alt={button.text}
                      className="button-image"
                    />
                  </a>
                ))}
              </div>
            </div>
            <div className="slide-productimg">
              <img src={item.image} alt={item.title} />
            </div>
          </div>
        ))}
      </div>

      {/* Slider Dots (Indicators) */}
      <div className="slider-dots">
        {data.map((_, index) => (
          <div
            key={index}
            className={`slider-dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => handleCircleClick(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Slider;
